import {
    OPEN_TARIFF_MODAL,
    CLOSE_TARIFF_MODAL,
    GET_TARIFF_LIST,
    TARIFF_CREATED,
    TARIFF_UPDATED,
    TARIFF_DELETED,
} from './salary.actionTypes';



export default function tariffDetails(state = { tariffList: [] }, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case OPEN_TARIFF_MODAL:
            return {
                ...newState,
                selectedTariff: action.selectedTariff,
                showModal: true
            }
        case CLOSE_TARIFF_MODAL:
            delete newState.selectedTariff;
            return {
                ...newState,
                showModal: false
            }
        case GET_TARIFF_LIST:
            return {
                ...newState,
                tariffList: action.tariffList
            }
        case TARIFF_CREATED:
            newState.tariffList.push(action.tariff)
            return newState;
        case TARIFF_UPDATED:
            const tariffList = newState.tariffList.map(tariff => {
                if(tariff._id === action.id) {
                    return action.tariff
                }
                return tariff;
            });
            return {
                ...newState,
                tariffList
            };
        case TARIFF_DELETED:
            return {
                ...newState,
                tariffList: newState.tariffList.filter(tariff => tariff._id !== action.id)
            };
        default:
            return newState;
    }
}